import React, { useEffect, useState } from "react";
import BlogCard from "../../Reusable/BlogCard/BlogCard.js";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import Adsense from "../../Reusable/Adsense/Adsense.js";
import Image from "components/Elements/Image/Image.tsx";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useNavigate } from "react-router-dom";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import config from "../../../config.ts";

import "./BlogPage.scss";

const BlogPage = () => {
  const [article, setArticle] = useState();
  const [moreArticles, setMoreArticles] = useState();
  const { getLanguageCulture, getTextByKey, getLanguage } = useContent();
  const { Desktop } = useMediaQueries();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (article !== undefined) {
      setLoading(true);
      const script = document.createElement("script");
      let itemJson = {
        "@context": "https://schema.org",
        "@type": "Article",
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": window.location.href,
        },
        headline: article.BlogArticleBrowserTitle,
        description: article.BlogMetaDataDescription,
        image: article.BlogFileLocation,
        author: {
          "@type": "Organization",
          name: "JUMBOmail",
        },
        publisher: {
          "@type": "Organization",
          name: "JUMBOmail",
          logo: {
            "@type": "ImageObject",
            url: `${config.api.resource}/assets/images/jumbomail-logo-black.svg`,
          },
        },
        datePublished: new Date(
          article.BlogArticleCreationDate
        ).toLocaleDateString(),
        dateModified: new Date(
          article.BlogArticleLastUpdateDate
        ).toLocaleDateString(),
      };
      script.type = "application/ld+json";
      script.innerText = JSON.stringify(itemJson);
      document.body.appendChild(script);
      setLoading(false);
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [article]);

  useEffect(() => {
    if (article) {
      if (
        getLanguage() === "en" ||
        getLanguage() === "es" ||
        getLanguage() === "it"
      ) {
        setLoading(true);
        const script = document.createElement("script");
        let itemJson = {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://www.jumbomail.me/" + getLanguage() + "/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Blog",
              item: "https://www.jumbomail.me/" + getLanguage() + "/blog",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: article.BlogArticleTitle,
              item:
                "https://www.jumbomail.me/" +
                getLanguage() +
                "/blog/" +
                article.BlogKey,
            },
          ],
        };

        script.type = "application/ld+json";
        script.innerText = JSON.stringify(itemJson);
        document.body.appendChild(script);
        setLoading(false);
        return () => {
          document.body.removeChild(script);
        };
      }
    }
  }, [article]);

  useEffect(() => {
    setLoading(true);
    apiRequest(
      "BlogArticles",
      `ReactGetBlogArticleByKey?blogKey=${
        window.location.href
          .substring(window.location.href.lastIndexOf("/") + 1)
          .split("#")[0]
      }&blogCulture=${getLanguageCulture()}`
    ).then((response) => {
      if (response.status !== "success") {
        navigate(`/${getLanguage()}/error/no-blog-id`);
      }
      setArticle(response.data);
    });

    apiRequest(
      "BlogArticles",
      `ReactGetMoreBlogArticles?blogKey=${
        window.location.href
          .substring(window.location.href.lastIndexOf("/") + 1)
          .split("#")[0]
      }&blogCulture=${getLanguageCulture()}`
    ).then((response) => {
      setMoreArticles(response.data);
      setLoading(false);
    });
  }, []);

  var getArticles = (articles) => {
    var html = [];
    html.push(
      <div key={articles[0].BlogArticleId} className="blog-page-articles">
        {articles.map((article) => {
          return <BlogCard key={article.BlogArticleId} article={article} />;
        })}
      </div>
    );
    return html;
  };

  return (
    <div className="blog-page-background">
      <Desktop>
        <Adsense bannerPosition="blog-left-side" />
      </Desktop>
      <Desktop>
        <Adsense bannerPosition="blog-right-side" />
      </Desktop>
      <div className="blog-page-wrapper">
        <div className="blog-page">
          <div className="blog-page-breadcrumbs">
            <a href="/">{getTextByKey("blog-home-breadcrumb")}</a>»
            <a href={`/${getLanguageCulture().substring(0, 2)}/blog`}>
              {getTextByKey("blog-blog-breadcrumb")}
            </a>
            »
            {/* <a href={`/${getLanguageCulture().substring(0,2)}/blog`}>
                            {article ? article.BlogArticleCategory : "Category"}
                        </a>
                        » */}
            <span>{article ? article.BlogArticleTitle : "Title"}</span>
          </div>
          {!loading ? (
            <div className="blog-article">
              <h1 className="blog-article-title">
                {article ? article.BlogArticleTitle : ""}
              </h1>
              {article && (
                <div className="blog-article-image">
                  <Image
                    title={article ? article.BlogArticleTitle : ""}
                    alt={article ? article.BlogArticleTitle : ""}
                    src={
                      article.BlogFileLocation
                        ? article.BlogFileLocation
                        : `${config.api.resource}/assets/images/blog-cover-img.jpg`
                    }
                  />
                </div>
              )}
              <div className="blog-article-text">
                <div
                  dangerouslySetInnerHTML={{
                    __html: article ? article.BlogArticleDescription : "",
                  }}
                ></div>
              </div>
            </div>
          ) : (
            <div className="loading-blog-container">
              <LoadingImageElement />
            </div>
          )}
        </div>
        {(moreArticles && moreArticles.length) > 0 && (
          <div className="blog-more-articles">
            <div className="blog-more-articles-title">
              {getTextByKey("jumbomail-blog-more-articles")}
            </div>
            {getArticles(moreArticles)}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogPage;
